import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

export function NavigationMenuComponent() {
  // get path from react router dom
  const location = useLocation();
  const pathname = location.pathname;

  const activeItem = useMemo(() => {
    if (pathname.includes('home'))
      return 'home';
    if (pathname.includes('life-documents'))
      return 'life-documents';
    if (pathname.includes('people'))
      return 'people';
    if (pathname.includes('vault'))
      return 'vault';
    if (pathname.includes('wellness'))
      return 'wellness';
  }, [ pathname ]);

  return (
    <div className="navigation-menu">
      <Link to="/home">
        <button>
          <span style={activeItem === 'home' ? { color: 'red' } : {}} className="material-symbols-outlined">home</span>
          <span className="home">Home</span>
        </button>
      </Link>
      <Link to="/people">
        <button>
          <span style={activeItem === 'people' ? { color: 'red' } : {}} className="material-symbols-outlined">group</span>
          <span className="people">People</span>
        </button>
      </Link>
      <Link to="/people/self/life-documents">
        <button>
          <span style={activeItem === 'life-documents' ? { color: 'red' } : {}} className="material-symbols-outlined">work</span>
          <span className="portfolios">Life Docs</span>
        </button>
      </Link>
      <Link to="/vault">
        <button>
          <span style={activeItem === 'vault' ? { color: 'red' } : {}} className="material-symbols-outlined">lock</span>
          <span className="vault">Vault</span>
        </button>
      </Link>
      <Link to="/wellness">
        <button>
          <span style={activeItem === 'wellness' ? { color: 'red' } : {}} className="material-symbols-outlined">cardiology</span>
          <span className="wellness">Wellness</span>
        </button>
      </Link>
    </div>
  );
}
